
import { formatDate } from "@/lib/formatDate"
import { Remarkable } from 'remarkable';
import { useEffect, useState } from 'react';

export default function RelatedCaseStudies({ caseStudies, related, actual }) {
  const blogsortByDateCreated = caseStudies.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });


  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data.industries.includes(related[0]) && data.title !== actual;
  })

  if (blogFiltered.length < 3) {
    const relatedRegions = blogsortByDateCreated.filter((data) => {
      return data.regions.includes(related[2]) && data.title !== actual;
    });
    const uniqueTitles = blogFiltered.map((element) => element.title);
    const uniqueRegionElements = relatedRegions.filter((element) => {
      return !uniqueTitles.includes(element.title);
    });
    const elementsToAdd = 3 - blogFiltered.length;
    if (uniqueRegionElements.length >= elementsToAdd) {
      blogFiltered.push(...uniqueRegionElements.slice(0, elementsToAdd));
    } else {
      blogFiltered.push(...uniqueRegionElements);
      const remainingElements = elementsToAdd - uniqueRegionElements.length;
      const remainingElementsToAdd = blogsortByDateCreated
        .filter((data) => !uniqueTitles.includes(data.title) && data.title !== actual)
        .slice(0, remainingElements);

      blogFiltered.push(...remainingElementsToAdd);
    }
  }



  const [blogsFetched, setBlogsFetched] = useState(blogFiltered.slice(0, 3));

  return (
    <div className="bg-white py-24 sm:py-32 font-['Inter']">
      <div className="mx-auto max-w-8xl px-4 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="medium-title">Related Case Studies</h2>
          {/* <p className="mt-2 text-lg leading-8 text-gray-600">
            Learn how to grow your business with our expert advice.
          </p> */}
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-6 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {blogsFetched.map((post) => (
            <article key={post.urlPath} className="flex flex-col items-start justify-between">
              <div className="relative w-full">
                <img
                  src={`${post?.image ? post.image : "/assets/images/layout/datopian-logo-black.png"}`}
                  alt="Case Study Image"
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl h-full">
                <div className="mt-8 flex items-center gap-x-4 text-xs">

                  <span className="text-gray-500">
                    {post?.readingTime ? post.readingTime + " min read" : "0 min read"}
                  </span>
                </div>
                <div className="group relative flex flex-col justify-start h-[8rem]">
                  <h3 className="mt-3 text-lg font-bold text-gray-900 group-hover:text-gray-600 line-clamp-1">
                    <a href={`/${post.urlPath}`}>
                      <span className="absolute inset-0" />
                      {post.title.length > 52 ? post.title.substring(0, 51) + '...' : post.title}
                    </a>
                  </h3>
                  <p className="mt-5 line-clamp-3  body-text">{post.description || post.brief}</p>
                </div>
                <div className="relative mt-6 flex items-center gap-x-4 text-start">
                  <img src={Array.isArray(post.avatarUrl) == true ? post.avatarUrl[0] : post.avatarUrl} alt="Author Image" className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover" />
                  <div className="text-sm leading-6">
                    <p className="font-semibold text-maingray">
                      <a href="#">
                        <span className="" />
                        {post.authors[0]}
                      </a>
                    </p>
                    <time dateTime={post.created} className="text-secgray">
                      {new Date(post.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </time>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
